import PersonGroupProfile from './PersonGroupProfile.container';

export default PersonGroupProfile;
